import { Bot, Building2, ChartNoAxesCombined, Megaphone, MessagesSquare, Settings2, ShieldCheck, Store, Workflow } from "lucide-react";

export const dashboardNavigation = [
  { label: "Conversations", path: "/chat", icon: MessagesSquare },
  { label: "Chatbot builder", path: "/chatbot-builder", icon: Workflow },
  { label: "Campaigns", path: "/campaign", icon: Megaphone },
  { label: "E-commerce", path: "/settings?tab=ecomm", icon: Store },
  { label: "Settings", path: "/settings", icon: Settings2 },
];

export const adminNavigation = { label: "Super admin", path: "/super-admin", icon: ShieldCheck };

// Retain the existing numeric deep links, including the E-commerce alias.
export function settingsSectionFromSearch(search: string) {
  const tab = new URLSearchParams(search).get("tab");
  if (tab === "ecomm") return 8;
  const id = Number(tab);
  return Number.isInteger(id) && id >= 0 && id <= 8 ? id : 0;
}

export function dashboardDestination(pathname: string, search = "") {
  if (pathname === "/super-admin") return adminNavigation;
  if (pathname === "/settings") {
    const tab = settingsSectionFromSearch(search);
    if (tab === 8) return dashboardNavigation[3];
    if (tab === 7) return dashboardNavigation[2];
    return dashboardNavigation[4];
  }
  if (pathname === "/campaign") return dashboardNavigation[2];
  if (pathname === "/agent" || pathname.startsWith("/agent/")) return { label: "Agents", path: "/agent", icon: Bot };
  if (pathname === "/original-dashboard") return { label: "Overview", path: "/original-dashboard", icon: ChartNoAxesCombined };
  if (pathname === "/scheduled_messages") return { label: "Scheduled messages", path: "/scheduled_messages", icon: Building2 };
  return dashboardNavigation.find(item => item.path === pathname || pathname.startsWith(`${item.path}/`)) || { label: "Workspace", path: "", icon: MessagesSquare };
}
